import {
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { Add, ExpandMore, FiberManualRecord, Room } from "@mui/icons-material";

import EmailWithCopyAndSend from "components/Texts/EmailWithCopyAndSend";
import PhoneWithWhatsapp from "components/Texts/PhoneWithWhatsapp";
import MaskAndValid from "utils/maskAndValid.js";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const useCardStyles = makeStyles({
  cardAction: ({ status }) => ({
    display: "flex",
    alignItems: "center",
    alignSelf: "center",
    height: "100%",
    marginTop: "0.1rem",
    color:
      status === "ATIVO"
        ? themeColorsDesingSystem.green.main
        : status === "INATIVO"
        ? themeColorsDesingSystem.yellow.main
        : themeColorsDesingSystem.red.main,
    marginRight: "0.1rem",
  }),
});

export default function CardLojista({
  dataCard,
  isMobile,
  isRegistered,
  onRegisterClick,
}) {
  const cardClasses = useCardStyles({ status: dataCard?.Status });

  return (
    <Grid item xs={isMobile ? 12 : 6}>
      <Card>
        <CardHeader
          classes={{ action: cardClasses.cardAction }}
          title="Lojista"
          titleTypographyProps={{
            component: Typography,
            variant: "h2",
          }}
          action={
            dataCard && (
              <>
                <FiberManualRecord />
                <Typography
                  variant="caption"
                  style={{ textTransform: "capitalize" }}
                >
                  {dataCard.Status.toLowerCase()}
                </Typography>
              </>
            )
          }
        ></CardHeader>
        <Accordion defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Box
              display="flex"
              flexGrow="1"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
            >
              <Box>
                <Typography>Dados Básicos</Typography>
              </Box>
              {!isRegistered ? (
                <Box>
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      onRegisterClick();
                    }}
                    variant="outlined"
                    startIcon={<Add />}
                  >
                    Criar
                  </Button>
                </Box>
              ) : null}
            </Box>
          </AccordionSummary>

          <AccordionDetails>
            <Box textAlign="left">
              <Typography variant="h4">
                Código ERP:
                <Box component="span" fontWeight="200">
                  {dataCard.CodERP ? " " + dataCard.CodERP : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                CNPJ:
                <Box component="span" fontWeight="300">
                  {dataCard.CnpjCpfPessoa
                    ? " " + MaskAndValid.maskCPNJCPF(dataCard.CnpjCpfPessoa)
                    : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Razão Social:
                <Box component="span" fontWeight="300">
                  {dataCard.Nome ? " " + dataCard.Nome : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Inscrição Estadual:
                <Box component="span" fontWeight="300">
                  {dataCard.InscricaoEstadual
                    ? " " + dataCard.InscricaoEstadual
                    : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Nome Contato:
                <Box component="span" fontWeight="300">
                  {dataCard?.NomeContato ? " " + dataCard?.NomeContato : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Código CC:
                <Box component="span" fontWeight="300">
                  {dataCard.CcLojista ? " " + dataCard.CcLojista : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Descrição CC:
                <Box component="span" fontWeight="300">
                  {dataCard.CcNome ? " " + dataCard.CcNome : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Código Grupo:
                <Box component="span" fontWeight="300">
                  {dataCard.CodGrupo && dataCard.CodGrupo !== 0
                    ? " " + dataCard.CodGrupo
                    : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Nome Grupo:
                <Box component="span" fontWeight="300">
                  {dataCard.NomeGrupo ? " " + dataCard.NomeGrupo : ""}
                </Box>
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Contatos</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box textAlign="left">
              <Typography variant="h4">
                Telefone:{" "}
                <Box component="span" fontWeight="300">
                  <PhoneWithWhatsapp phone={dataCard?.FonePrincipal} />
                </Box>
              </Typography>
              <Typography variant="h4">
                Celular:{" "}
                <Box component="span" fontWeight="300">
                  <PhoneWithWhatsapp phone={dataCard?.FoneCelular} />
                </Box>
              </Typography>
              <Typography variant="h4">
                Telefone Recado:{" "}
                <Box component="span" fontWeight="300">
                  <PhoneWithWhatsapp phone={dataCard?.FoneRecado} />
                </Box>
              </Typography>
              <Typography variant="h4">
                E-mail contato:{" "}
                <Box component="span" fontWeight="300">
                  <EmailWithCopyAndSend email={dataCard?.EmailPrincipal} />
                </Box>
              </Typography>
              <Typography variant="h4">
                E-mail alternativo:{" "}
                <Box component="span" fontWeight="300">
                  <EmailWithCopyAndSend email={dataCard?.EmailAlternativo} />
                </Box>
              </Typography>
              <Typography variant="h4">
                E-mail NFe:{" "}
                <Box component="span" fontWeight="300">
                  <EmailWithCopyAndSend email={dataCard?.EmailNfe} />
                </Box>
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Endereços</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box textAlign="left">
              <Typography variant="h3" color="primary">
                Principal
              </Typography>
              <Typography variant="h4">
                Logradouro:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndPrincipalRua : ""}
                </Box>
                {dataCard &&
                Boolean(dataCard.EndPrincipalRua) &&
                dataCard.EndPrincipalRua.trim() > "" ? (
                  <IconButton
                    size="small"
                    href={
                      "https://www.google.com/maps/place/" +
                      MaskAndValid.formattAddressGoogleMaps(
                        dataCard.EndPrincipalRua,
                        dataCard.EndPrincipalNumero,
                        dataCard.EndPrincipalBairro,
                        dataCard.EndPrincipalCidade,
                        dataCard.EndPrincipalUf,
                        dataCard.EndPrincipalCep
                      )
                    }
                    target="_blank"
                  >
                    <Room
                      fontSize="large"
                      style={{ marginLeft: 5, marginBottom: 1 }}
                    ></Room>
                  </IconButton>
                ) : (
                  ""
                )}
              </Typography>
              <Typography variant="h4">
                Número:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndPrincipalNumero : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Bairro:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndPrincipalBairro : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Cidade:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndPrincipalCidade : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Uf:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndPrincipalUf : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                CEP:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard
                    ? MaskAndValid.maskCEP(dataCard.EndPrincipalCep)
                    : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Complemento:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndPrincipalComplemento : ""}
                </Box>
              </Typography>
              <Divider
                variant={"fullWidth"}
                style={{ marginTop: "15px", marginBottom: "15px" }}
              />
              <Typography variant="h3" color="primary">
                Entrega
              </Typography>
              <Typography variant="h4">
                Logradouro:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndEntregaRua : ""}
                </Box>
                {dataCard &&
                Boolean(dataCard.EndEntregaRua) &&
                dataCard.EndEntregaRua.trim() > "" ? (
                  <IconButton
                    size="small"
                    href={
                      "https://www.google.com/maps/place/" +
                      MaskAndValid.formattAddressGoogleMaps(
                        dataCard.EndEntregaRua,
                        dataCard.EndEntregaNumero,
                        dataCard.EndEntregaBairro,
                        dataCard.EndEntregaCidade,
                        dataCard.EndEntregaUf,
                        dataCard.EndEntregaCep
                      )
                    }
                    target="_blank"
                  >
                    <Room
                      fontSize="large"
                      style={{ marginLeft: 5, marginBottom: 1 }}
                    ></Room>
                  </IconButton>
                ) : (
                  ""
                )}
              </Typography>
              <Typography variant="h4">
                Número:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndEntregaNumero : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Bairro:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndEntregaBairro : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Cidade:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndEntregaCidade : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Uf:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndEntregaUf : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                CEP:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard && dataCard.EndEntregaCep
                    ? MaskAndValid.maskCEP(dataCard.EndEntregaCep)
                    : ""}
                </Box>
              </Typography>
              <Typography variant="h4">
                Complemento:{" "}
                <Box component="span" fontWeight="300">
                  {dataCard ? dataCard.EndEntregaComplemento : ""}
                </Box>
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Card>
    </Grid>
  );
}
